import { 
    SET_GRADE_PRIMARIA, 
    SET_GRADE_SECUNDARIA, 
    SET_GRADE_PRIMARIA_SELECIONADA_ID,
    SET_GRADE_SECUNDARIA_SELECIONADA_ID,
    SET_QTD_ESTOQUE
} from './mutation-types'


export default {
    [SET_GRADE_PRIMARIA](state, payload) {
        state.gradePrimaria = payload;
    },
    [SET_GRADE_SECUNDARIA](state, payload){
        state.gradeSecundaria = payload;
    },
    [SET_GRADE_PRIMARIA_SELECIONADA_ID](state, payload){
        state.gradePrimariaSelecionadaId = payload || null;
    },
    [SET_GRADE_SECUNDARIA_SELECIONADA_ID](state, payload){
        state.gradeSecundariaSelecionadaId = payload || null;
    },
    [SET_QTD_ESTOQUE](state, payload) {
        state.qtdEstoque = payload || 0
    }
}